import React, { useEffect, useState, useMemo } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getClients,
  restartClient,
} from "../../../redux/actions/admin/clientActions";
import { useTranslation } from "react-i18next";

import {
  useTable,
  useSortBy,
  usePagination,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";

// components;
import { Pagination, InputSearch, TableGrid, Success } from "../../common";

export default function VacantMain() {
  let { url } = useRouteMatch();
  const { t, i18n } = useTranslation("common");

  const columns = useMemo(
    () => [
      {
        Header: () => t("personal.name"),
        accessor: "name_clients",
      },
      {
        Header: () => t("vacancies.ubication"),
        accessor: "ubication_clients",
      },
      {
        Header: () => t("clients.dateCreate"),
        accessor: "created_at",
        Cell: ({ value: created_at }) => {
          const localeFormat = i18n.language === "en" ? "en-US" : "es-CO";
          return new Date(created_at).toLocaleDateString(localeFormat);
        },
      },
      {
        Header: () => t("clients.status"),
        accessor: "status_clients",
        Cell: ({ value: status_clients }) => (
          <>
            {status_clients === "I" ? (
              <span className="inline-block px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-full dark:bg-green-700 dark:text-red-100">
                {t("clients.inactive")}
              </span>
            ) : (
              <span className="inline-block px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-red-100">
                {t("clients.active")}
              </span>
            )}
          </>
        ),
      },
      {
        Header: () => t("skills.actions_test"),
        accessor: "name_client",
        Cell: ({ row: { original: item } }) => (
          <div className="flex justify-center text-sm">
            <div className="my-1.5 border-2 border-yellow-500 hover:bg-yellow-500 text-yellow-500 hover:text-white font-semibold  mx-1 py-2 px-2 rounded-lg">
              <Link to={`${url}/edit/${item.uuid}`}>
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="my-1.5 border-2 border-red-500  hover:bg-red-500 text-red-500 hover:text-white font-bold mx-1 py-2 px-2 rounded-lg">
              <Link to={`${url}/delete/${item.uuid}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [url, t, i18n.language]
  );

  const clients = useSelector((state) => state.clientsReducers);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    globalFilter,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: clients.data,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const [value, setValue] = useState(globalFilter);

  const onChangeInputSearch = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restartClient());
  }, [dispatch]);

  useEffect(() => {
    if (!clients.loaded) dispatch(getClients());
  }, [dispatch, clients.loaded]);
  return (
    <>
      <div className="mt-5">
        <section className="text-gray-600 body-font">
          <div className="container px-5 pt-20 pb-4 mx-auto flex items-center md:flex-row flex-col">
            <div className="flex flex-col md:pr-10 md:mb-0 mb-6 pr-0 w-full md:w-auto md:text-left text-center">
              <h2 className="text-xs text-blue-500 tracking-widest font-medium title-font mb-2 bg-blue-50 rounded px-2 py-2 w-52">
                <i className="far fa-building mr-4"></i>
                {t("clients.clientList")}
              </h2>
              <h1 className="text-xl lg:text-2xl font-semibold title-font text-gray-900">
                {t("vacancies.listsclients")}
              </h1>
            </div>
            <div className="flex flex-col md:flex-row md:ml-auto md:mr-0 mx-auto items-start flex-shrink-0 space-x-4">
              <Link to={`${url}/add-clients`} className="mr-2 font-poppins">
                <button
                  className="bg-blue-100 inline-flex py-3 px-5 rounded-lg items-center hover:bg-blue-300 focus:outline-none"
                  variant="outlined"
                >
                  <i className="fa fa-plus mr-2"></i>
                  <span className="ml-4 flex items-start flex-col leading-none">
                    <span className="text-xs text-gray-600 mb-1">
                      {t("question.add")}
                    </span>
                    <span className="title-font font-medium">
                      {t("clients.newClients")}
                    </span>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Success
        status={clients.success}
        styleParent="mt-5"
        message={clients.success_message}
        closer="CLIENTS_SUCCESS_OFF"
      />

      <InputSearch
        setValue={setValue}
        onChange={onChangeInputSearch}
        value={value}
      />
      <TableGrid
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        loaded={clients.loaded}
        getTableBodyProps={getTableBodyProps}
        page={page}
        prepareRow={prepareRow}
      />
      <Pagination
        previousPage={previousPage}
        canPreviousPage={canPreviousPage}
        nextPage={nextPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </>
  );
}
